<div class="content-wrapper-inner">
  <div class="page-content">
    <div class="mb-20">
      <app-appscripts-payment-request-filter (onSubmit)="onFilter($event)"></app-appscripts-payment-request-filter>
    </div>
    <div class="pos-relative">
      <app-appscripts-payment-request-table (changeBatch)="selectedRows = $event" (actions)="action($event)">
      </app-appscripts-payment-request-table>
      <div class="table-action-info-bar" *ngIf="selectedRows.length">
        <div class="info-left">
          <div class="text-icon-holder" (click)="batchClear()">
            <span class="icon">
              <span class="selected icon-done"></span>
            </span>
            <span class="text">{{selectedRows.length}} Selected</span>
          </div>
        </div>
        <div class="info-right">
          <div class="text-icon-holder" (click)="onClickCopyPhones()">
            <span class="icon">
              <i class="fa fa-mobile-phone"></i>
            </span>
            <span class="text">Copy phones</span>
          </div>
          <div class="text-icon-holder" (click)="onClickCopyEmails()">
            <span class="icon">
              <i class="fa fa-mobile-phone"></i>
            </span>
            <span class="text">Copy emails</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchMarkAsPaid()">
            <span class="icon">
              <i class="fa fa-trash"></i>
            </span>
            <span class="text">Mark as paid</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchMarkAsFailed()">
            <span class="icon">
              <i class="fa fa-trash"></i>
            </span>
            <span class="text">Mark as failed</span>
          </div>
          <div class="text-icon-holder" (click)="onBatchDelete()">
            <span class="icon">
              <i class="fa fa-trash"></i>
            </span>
            <span class="text">Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #copyPhonesModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phones</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body info-content">
    <textarea [(ngModel)]="copyPhonesText" (click)="onClickCopyPhonesControl($event)" class="form-control copy-control" [attr.rows]="copyPhonesTextControlRows"
      readonly></textarea>
  </div>
</ng-template>

<ng-template #paymentRequestUpdateModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Payment request {{model.id}}</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-appscripts-payment-request-form (onAfterSave)="onAfterSavePaymentRequest()" [model]="model"
      [buttonsShow]="false"></app-appscripts-payment-request-form>
  </div>
  <div class="modal-footer">
    <button [disabled]="!form || form.form.disabled" class="btn btn-primary mt-10">Apply</button>
  </div>
</ng-template>
